import script from "./HtmlToPdfPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HtmlToPdfPage.vue?vue&type=script&setup=true&lang=js"

import "./HtmlToPdfPage.vue?vue&type=style&index=0&id=c8fbb3d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8fbb3d8"]])

export default __exports__